import { Component, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LeagueService } from '../services/league.service';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-league',
  templateUrl: './new-league.component.html',
  styleUrls: ['./new-league.component.css']
})
export class NewLeagueComponent implements OnInit {

  loading = false;
  err = '';
  successMessage: string = "";

  constructor(private leagueService: LeagueService, private router: Router) { }

  ngOnInit(): void {

  }

  createLeague(newLeague: NewLeague) {
    this.loading = true;
    this.successMessage = "";
    this.err = "";
    this.leagueService.createNewLeague(newLeague)
      .subscribe(
        (league: League) => {
          this.successMessage = 'League created successfully';
          setTimeout(() => {
            this.router.navigate(['/leagues/']);
          }, 1500);
        },
        err => {
          this.err = err.error.detail;
          this.loading = false;
        }
      );
  }

}
